export default __webpack_public_path__ + "static/e-mec-9db3f7bd85edd8383fa61d67068c9541.jpg";